<template>
  <div class="item-wrapper one">
    <div class="d-flex flex-wrap row mb-3">
      <UploadPreview
        v-for="(item,idx) in files"
        :key="idx"
        :item="item"
        v-on:removeItem="removeItem"
        v-on:cancelUpload="cancelUpload"
      />
    </div>

    <div class="item">
      <form data-validation="true" action="#" method="post" enctype="multipart/form-data">
        <div class="item-inner">
          <div class="item-content">
            <div
              class="image-upload"
              v-bind:class="isDragover?'is-dragover':''"
              v-on:dragover="dragover"
              v-on:dragleave="dragleave"
            >
              <label style="cursor: pointer;" for="file_upload">
                <div class="h-100">
                  <div class="dplay-tbl">
                    <div class="dplay-tbl-cell">
                      <i class="fas fa-cloud-upload-alt"></i>
                      <h5>
                        <b>choose photo</b>
                      </h5>
                      <h6 class="mt-10 mb-70">or drag it here</h6>
                    </div>
                  </div>
                </div>
                <!--upload-content-->
                <input
                  data-required="image"
                  type="file"
                  multiple
                  id="file_upload"
                  class="image-input"
                  @change="doUpload"
                  data-traget-resolution="image_resolution"
                  value
                  accept="image/*"
                />
              </label>
            </div>
          </div>
          <!--item-content-->
        </div>
        <!--item-inner-->
      </form>
    </div>
    <!--item-->
  </div>
</template>

<script>
import UploadPreview from "@/components/UploadPreview";
import axios from "axios";

export default {
  props: {
    options: {
      headers: {
        type: Object,
        default: {}
      },
      url: {
        type: String,
        default: ""
      }
    }
  },
  components: {
    UploadPreview
  },
  data() {
    return {
      uploads: [],
      isDragover: false
    };
  },
  computed: {
    files: {
      get() {
        return this.uploads || [];
      },
      set(newVal) {
        this.uploads = newVal;
      }
    }
  },
  methods: {
    dragover() {
      this.isDragover = true;
    },
    dragleave() {
      this.isDragover = false;
    },
    reset() {
      this.uploads = [];
      this.isDragover = false;
    },
    addFile(file) {
      file.completed = true;
      this.files.push(file);
    },
    removeItem(id) {
      let idx = this.files.findIndex(file => file.id == id);
      //console.log(idx);
      this.files.splice(idx, 1);
      this.$emit("removedEvent", id);
    },
    createImage(file, data) {
      //var image = new Image();
      var reader = new FileReader();

      reader.onload = e => {
        file.src = e.target.result;
      };
      reader.readAsDataURL(data);
    },
    doUpload(e) {
      var uploads = e.target.files || e.dataTransfer.files;
      if (!uploads.length) return;
      uploads.forEach((upload, idx) => {
        let file = {
          src: "",
          progress: 0,
          completed: false,
          xhr: axios.CancelToken.source()
        };
        this.createImage(file, upload);
        var formData = new FormData();
        this.$emit("uploadingEvent", file, formData);
        formData.append("file", upload);

        axios
          .post(this.options.url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              ...this.options.headers
            },
            onUploadProgress: function(progressEvent) {
              var percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              file.progress = percentCompleted;
            },
            cancelToken: file.xhr.token
          })
          .then(res => {
            file.completed = true;
            this.$emit("completedEvent", file, res.data);
          })
          .catch(err => {
            console.log(err);
          });
        this.uploads.push(file);
      });
    },
    cancelUpload(file) {
      file.xhr.cancel();
      let idx = this.files.indexOf(file);
      this.files.splice(idx, 1);
    }
  }
};
</script>

<style scoped>
.image-upload {
  width: 100%;
  padding: 20px;
  border: 2px dashed #ddd;
  border-radius: 5px;
  margin-bottom: 20px;
  position: relative;
  text-align: center;
  background: #f8f8f9;
  color: #666;
  overflow: hidden;
}

.image-upload.is-dragover {
  background: #f1f1f3;
  color: #444;
  border: 2px dashed #b7b7bb;
}
.image-upload:hover i,
.image-upload.is-dragover i {
  color: #999;
}

.item-wrapper form img {
  margin-bottom: 20px;
  width: auto;
  height: auto;
  max-height: 400px;
  width: auto;
  border-radius: 5px;
  overflow: hidden;
}

.image-upload img {
  height: 100% !important;
  width: auto !important;
  border-radius: 0px;
  margin: 0 auto;
}

.image-upload i {
  font-size: 4em;
  color: #ccc;
}

.image-upload input {
  cursor: pointer;
  opacity: 0;
  height: 100%;
  width: 100%;
  z-index: 10;
  position: absolute;
  top: 0;
  left: 0;
}

.item-wrapper input {
  height: 100%;
  line-height: 43px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 20px;
}
</style>